export default __webpack_public_path__ + "static/media/dg-icon-active.d1e7b11d.svg";